const config = { attributes: false, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
        const ptvp = document.querySelector('.bss-lock-ptvp-element script[type="text/javascript"]');
        if (!ptvp) return
        if (ptvp.parentNode.querySelector('#ptvp-script')) return;
        
        const newScript = document.createElement('script');
        newScript.text = ptvp.textContent;
        newScript.id = 'ptvp-script';
        ptvp.parentNode.appendChild(newScript);
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(document.body, config);
